import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Divider,
  Flex,
  Link,
  Text
} from '@chakra-ui/react';

import { ImportSources } from '../../../constants/importStatuses';
import { useImport } from '../../../services/import-service';
import colors from '../../../styles/theme/foundation/colors';

import ImportStatusBadge from './ImportStatusBadge';
import ImportWizard from './ImportWizard';
import { formatDateTime } from './util';

const ImportDetail = () => {
  const { importId } = useParams();
  const { data: importData, isLoading, isError, error } = useImport(importId);

  return (
    <Box bg={colors.white} minH="700px" p={6} w="1050px">
      <Link as={RouterLink} color="primaryScale.700" textStyle="bodySm" to="/pinsadmin/imports">← All imports</Link>

      {isLoading && <Text mt={4}>Loading...</Text>}

      {isError && (
        <Alert borderRadius="md" mt={4} status="error">
          <AlertIcon />
          <AlertDescription>{error?.message || 'The import could not be loaded.'}</AlertDescription>
        </Alert>
      )}

      {importData && (
        <>
          <Box mt={2}>
            <Flex alignItems="center" gap={3}>
              <Text textStyle="displayXs">{importData.name}</Text>
              <ImportStatusBadge status={importData.status} />
            </Flex>
            <Text color="greyScale.500" textStyle="bodySm">
              {[
                `Import #${importData.id}`,
                `company ${importData.companyId}`,
                importData.source === ImportSources.dropbox ? `Dropbox ${importData.sourcePath}` : 'browser upload',
                `created ${formatDateTime(importData.createdAt)}`,
                importData.forceAiExtraction ? 'forced AI extraction' : null
              ].filter(Boolean).join(' · ')}
            </Text>
          </Box>

          <Divider my={4} />
          <ImportWizard importData={importData} />
        </>
      )}
    </Box>
  );
};

export default ImportDetail;
